export default __webpack_public_path__ + "static/media/calendar (2).9093c186.svg";